export const initialPagination = {
  PAGE: 1,
  ITEMS_PER_PAGE: 10
} as const

export interface PaginationParams {
  page?: number | null
  itemsPerPage?: number | null
}

export interface PaginationProps {
  currentPage?: number
  totalPages?: number
  itemsPerPage?: number
  totalItems?: number
  onPageChange?: (value: number) => void
  onItemsPerPageChange?: (value: number) => void
}
